import React from 'react';
import { Redirect } from 'react-router-dom';
import firebase from '../firebase';

class Admin extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      admin: false,
      wait: true
    };
  }

  componentDidMount = () => {
    this.unsubscribeAuthStateChanged = this.props.firebase.auth().onAuthStateChanged(this.handleAuthStateChange);
  }

  componentWillUnmount = () => {
    if (this.unsubscribeAuthStateChanged) {
      this.unsubscribeAuthStateChanged();
    }
  }

  handleAuthStateChange = (user) => {
    if (!user) return;
    this.props.firebase.database().ref(`admins/${user.uid}`).once('value', (snapshot) => {
      if (typeof snapshot.val() !== 'undefined') {
        this.setState({admin: snapshot.val(), wait: false});
      } else {
        this.setState({wait: false});
      }
    }, () => {
      this.setState({wait: false});
    });
  }

  render() {

    if (!this.state.admin && !this.state.wait) {
      return (
        <Redirect to='/'/>
      );
    }

    return (
      null
    );
  }
}

export default firebase(Admin);



// WEBPACK FOOTER //
// ./src/Auth/Admin.js